module.exports = "/_next/static/images/32102d1cb443e6d09330a0a305d94d25-cross-circle.svg.webp";